import clsx from 'clsx';
import React, { useMemo, useState } from 'react';
import PriceModel, {
  TierPrice as TierPriceType,
} from '../../Types/PriceModel';
import { translate } from '../../Services/translation';

interface ProductPriceProps {
  priceModel: PriceModel;
  itemPackageSize?: number;
  showTierPrices?: boolean;
}
const ProductPrice = ({
  priceModel,
  itemPackageSize = 1,
  showTierPrices = false,
}: ProductPriceProps) => {
  const tierPriceBoxes = useMemo(() => {
    let index = priceModel.tierPrices.findIndex(
      (f) => f.minimumQuantity == itemPackageSize
    );

    if (index > -1 && itemPackageSize > 1 && showTierPrices) {
      return priceModel.tierPrices[index];
    } else {
      return undefined;
    }
  }, [itemPackageSize, priceModel, showTierPrices]);

  return (
    <div className={clsx('flex', 'flex-col')}>
      {priceModel.formattedCampaignPrice ? (
        <div className="mb-2 text-sm font-normal leading-normal text-campaign">
          {priceModel.formattedCampaignPrice}
          <span className="ml-[3px] self-end text-xs font-light leading-normal text-gray-500">
            {priceModel.price?.unitOfMeasurementTitle && '/ '}
            {priceModel.price?.unitOfMeasurementTitle?.toLowerCase()}
          </span>
          <span className="ml-2 text-sm font-normal text-gray-500 line-through">
            {priceModel.formattedPrice}
          </span>
        </div>
      ) : priceModel.formattedPrice ? (
        <>
          <div
            className={clsx(
              'leading-normal',
              tierPriceBoxes
                ? 'flex self-end pb-1 text-sm font-normal'
                : 'flex text-sm font-normal'
            )}
          >
            {priceModel.formattedPrice}
            <span className="ml-[3px] self-end text-xs font-light leading-normal text-gray-500">
              {priceModel.price?.unitOfMeasurementTitle && '/ '}
              {priceModel.price?.unitOfMeasurementTitle?.toLowerCase()}
            </span>
          </div>
          {tierPriceBoxes && (
            <TierPrice
              currencySymbol={priceModel.currency.symbol}
              price={tierPriceBoxes.price}
              unit={priceModel.price?.unitOfMeasurementTitle}
            />
          )}
        </>
      ) : (
        <div className="flex text-sm font-normal">
          {priceModel.formattedPrice}
          <span className="ml-0.5 contents h-[1em] self-end text-xs font-light leading-normal text-gray-500">
            &nbsp;
          </span>
        </div>
      )}
    </div>
  );
};

const TierPrice = ({
  currencySymbol,
  price,
  unit,
}: {
  currencySymbol: string;
  price: number;
  unit?: string;
}) => {
  return (
    <span className="self-end text-right text-sm font-light leading-none text-gray-500">
      {`${price} ${currencySymbol} / ${unit?.toLowerCase()} ${translate(
        'product-page.tier-price.box-price'
      )}`}
    </span>
  );
};

export default ProductPrice;
